var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3269,
    r: 14,
    fill: "#F38D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.973 10.327C20.4597 10.5603 19.9064 10.7137 19.333 10.787C19.9197 10.4337 20.373 9.87365 20.5864 9.20032C20.033 9.53365 19.4197 9.76699 18.773 9.90032C18.2464 9.32699 17.5064 8.99365 16.6664 8.99365C15.0997 8.99365 13.8197 10.2737 13.8197 11.8537C13.8197 12.0803 13.8464 12.3003 13.893 12.507C11.5197 12.387 9.40637 11.247 7.9997 9.52032C7.75303 9.94032 7.61303 10.4337 7.61303 10.9537C7.61303 11.947 8.11303 12.827 8.88637 13.327C8.41303 13.327 7.97303 13.1937 7.58637 12.9937V13.0137C7.58637 14.4003 8.57303 15.5603 9.8797 15.8203C9.46019 15.9351 9.01976 15.9511 8.59303 15.867C8.77411 16.4353 9.12873 16.9326 9.60705 17.2889C10.0854 17.6453 10.6633 17.8428 11.2597 17.8537C10.2488 18.6539 8.9957 19.0865 7.70637 19.0803C7.4797 19.0803 7.25303 19.067 7.02637 19.0403C8.29303 19.8536 9.7997 20.327 11.413 20.327C16.6664 20.327 19.553 15.967 19.553 12.187C19.553 12.0603 19.553 11.9403 19.5464 11.8137C20.1064 11.4137 20.5864 10.907 20.973 10.327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitter);
export default __webpack_public_path__ + "static/media/logo_twitter.c063bf43549d0c0d3735c686d82991a8.svg";
export { ForwardRef as ReactComponent };